import React from "react";
import { Select } from "@blueprintjs/select";
import { Button, MenuItem, Menu, MenuDivider } from "@blueprintjs/core";

export default function ProductSelect({
  loading,
  products,
  value,
  onChange,
  className = ""
}) {
  function filterItem(query, currentItem) {
    const normalizedQuery = query.toLowerCase().trim();
    const normalizedProductName = currentItem.name.toLowerCase().trim();
    return normalizedProductName.includes(normalizedQuery);
  }

  function renderItem(item, { handleClick, modifiers }) {
    return (
      <MenuItem
        key={item.id}
        text={item.name}
        onClick={handleClick}
        active={value && item.id == value.id}
        disabled={modifiers.disabled}
      />
    );
  }

  function renderItemList({ items, itemsParentRef, query, renderItem }) {
    const partneredProducts = items.filter((item) => item.partneredProduct);
    const ownedProducts = items.filter((item) => !item.partneredProduct);
    if (partneredProducts.length) {
      return (
        <Menu ulRef={itemsParentRef}>
          {ownedProducts.length > 0 && <MenuDivider title="Owned Products" />}
          {ownedProducts.map(renderItem)}
          <MenuDivider title="Partnered Products" />
          {partneredProducts.map(renderItem)}
        </Menu>
      );
    } else {
      return <Menu ulRef={itemsParentRef}>{items.map(renderItem)}</Menu>;
    }
  }

  return (
    <Select
      items={products}
      itemListRenderer={renderItemList}
      itemRenderer={renderItem}
      itemPredicate={filterItem}
      noResults={<MenuItem disabled text="No results." />}
      onItemSelect={onChange}
      className={className}
    >
      <Button
        text={value ? value.name : "Select a Product"}
        rightIcon="chevron-down"
        alignText="left"
        loading={loading}
        fill
      />
    </Select>
  );
}
